import { ProductDataType } from 'app/models/types/store/product';
import { ProductsId, productsConfig } from '@webc/meeseeks-ui-sdk';
import sumBy from 'lodash/sumBy';

export const getProductsWithInvalidDependencies = (selectedProducts: {
  [key in ProductsId]?: ProductDataType;
}) => {
  const productsWithDependencies = Object.keys(productsConfig.productTypes).filter(
    (productId) =>
      productsConfig.productTypes[productId].requiredProductTypes?.length > 0 &&
      productsConfig.productTypes[productId],
  );
  const selectedProductsWithDependencies = Object.keys(selectedProducts).filter(
    (product) =>
      productsWithDependencies.includes(product) &&
      !productsConfig.productTypes[product]?.blockSelectionForMissingRequiredProducts,
  ) as ProductsId[];

  const invalidProductsWithDependencies = selectedProductsWithDependencies.filter(
    (currSelectedProductWithDependencies: string) => {
      const requiredProducts =
        productsConfig.productTypes[currSelectedProductWithDependencies].requiredProductTypes;
      const selectedRequiredProducts: ProductDataType[] = requiredProducts
        .map((requiredProduct) => selectedProducts[requiredProduct])
        .filter(Boolean);
      const selectedRequiredProductsSum = sumBy(
        selectedRequiredProducts,
        (selectedProduct) => selectedProduct.selectedAmount,
      );

      return (
        selectedProducts[currSelectedProductWithDependencies].selectedAmount >
        selectedRequiredProductsSum
      );
    },
  );
  return invalidProductsWithDependencies;
};
